import {
  CaptchaCompleteRequest,
  CaptchaCompleteResponse,
  CaptchaVerifyRequest,
  CaptchaVerifyResponse,
  GetWarningRuleRequest,
  GetWarningRuleResponse,
  UpsertWarningRuleRequest,
  UpsertWarningRuleResponse,
  WarningRule
} from "@/entities/channel/security-rule/api"

import { apiSlice } from "@/shared/api/api-slice"
import type { AIAntispamTrialState, AIAntispamTrialStatusResponse } from "@/shared/api/types"

/**
 * Security API endpoints
 */
export const securityApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getAIAntispamTrialStatus: builder.query<AIAntispamTrialState, number>({
      query: chatId => `/api/v1/security/rules/chat/${chatId}/ai-antispam-trial`,
      transformResponse: (response: AIAntispamTrialStatusResponse) => response.result
    }),

    getWarningRule: builder.query<WarningRule, GetWarningRuleRequest>({
      query: chatId => `/api/v1/security/warning/${chatId}`,
      transformResponse: (response: GetWarningRuleResponse) => response.result.rules,
      providesTags: (_, __, chatId) => [{ type: "WarningRule", id: chatId }]
    }),

    upsertWarningRule: builder.mutation<WarningRule, UpsertWarningRuleRequest>({
      query: request => ({
        url: `/api/v1/security/warning`,
        method: "PUT",
        body: request
      }),
      transformResponse: (response: UpsertWarningRuleResponse) => response.result.rules,
      invalidatesTags: (_, error, { chat_id }) => (error ? [] : [{ type: "WarningRule", id: chat_id }])
    }),

    verifyCaptcha: builder.mutation<CaptchaVerifyResponse, CaptchaVerifyRequest>({
      query: request => ({
        url: `/api/v1/captcha/verify`,
        method: "POST",
        body: request
      })
    }),

    completeCaptcha: builder.mutation<CaptchaCompleteResponse, CaptchaCompleteRequest>({
      query: request => ({
        url: `/api/v1/captcha/complete`,
        method: "POST",
        body: request
      })
    })
  })
})

export const {
  useGetAIAntispamTrialStatusQuery,
  useGetWarningRuleQuery,
  useUpsertWarningRuleMutation,
  useVerifyCaptchaMutation,
  useCompleteCaptchaMutation
} = securityApi
